import { useState } from "react";
import TrialResultDetails from "./Components/TrialResultDetails";
import { TrialResults } from "./Components";
import { PageProvider } from "shared/context/paginationCotnext";

export const TrialResult = () => {
  const [trial, setTrial] = useState(null);

  return (
    <PageProvider>
      <div className={"App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10"}>
          {trial ? (
            <TrialResultDetails
              trialData={trial}
              // setTrial={() => {
              //   const showResults = (id) => {
              //     navigate(`${id}`);
              //   };
              // }}
            />
          ) : (
            <TrialResults setTrial={setTrial} />
          )}
        </div>
    </PageProvider>
  );
};
